import { React, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';

// Assets
import homebanner from "../images/banner_images/laptop/home.png";
import mobhomebanner from '../images/banner_images/mobile/mobile_homebanner.png'
import lavikbanner from "../images/home/lavik_banner.png"
import mlavikbanner from "../images/mlavik_baner.png"
import industry from "../images/home/service_industry.png"
import liaison from "../images/home/service_liasion.png"
import residential from "../images/home/service_residential.png"
import anandhamayam from '../images/anandhamayam_logo.png'
import homebanner2 from '../images/home/home_banner_2.png'
import mhomebanner2 from '../images/home/mhome_banner_2.png'
import Trends from '../Components/Trends'
import Abode_bg from '../images/home/Abode_bg.svg'
import Abode from '../images/home/Abode.png' 
import abode_pdf from '../images/brochures/The abode_brochure.pdf'

// Components
import Banner from "../Components/Banner";
import FeaturedServices from '../Components/FeaturedServices';
import Button from '../Components/Button';
import FormModal from '../Components/FormModal';


function Home() {

    // Modal State & Function
        const [modalToggle, setModalToggle] = useState(false);
        function toggle() {
            setModalToggle(!modalToggle);
        }

    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);


    return (
        <>

            <Banner
                img={homebanner}
                mimg={mobhomebanner}
                alt={"banner_image"}
                heading={"End-to-end Real Estate Services - One Trusted Partner."}
                subheading={"Your partner from plan to possession."}
                button={"Work With Us"}
                textposition={"w-[85%] bottom-8 left-8 right-8 lg:w-[675px] lg:bottom-[100px] lg:left-[100px]"}
                renderButton={() => (
                    <Button 
                        name={"Get Started"}
                        design= {"filled"}
                        action={"scroll"}
                        section_id={"services"}
                    />
                )}
            />          

            

            {/* Our Services Section */}

            <div className="max-w-7xl mx-auto my-16">

                <div className='max-w-[950px] mx-auto'>
                    <h1 className='heading !font-noto'data-aos="fade-up">Future-focused real estate,<br className='hidden sm:block' />Grounded in trust</h1>
                    <hr className='border-yellow border-[2px] w-[87px] mx-auto my-[40px]' data-aos="fade-up"/>
                    <p className="service-description max-w-[750px] mx-auto" data-aos="fade-up" data-aos-duration="1100">We bring together investment, development, and services with a commitment to integrity, market expertise, and last‑mile access. Building today with the vision of tomorrow.</p>
                </div>

                <div className="flex flex-wrap mx-auto my-12 gap-x-9 gap-y-9 lg:my-20 ">

                    <div className="max-w-[394px] mx-auto bg-card-grey h-[608px]" data-aos="fade-up" data-aos-duration="700" data-aos-anchor-placement="top-bottom">
                        <img className="w-full" src={residential} alt="residential_image" />

                        <div className='max-w-[320px] mx-auto text-center py-[35px]'>
                            <h1 className="font-noto font-bold text-[32px] leading-[40px]">Residential</h1>
                            <p className='font-alibaba text-[17px] leading-[26px] text-[#5F5D5E] mt-[20px] mb-[60px]'>Homes bought, sold, and rented — without the hassle.</p>

                            <Button
                                name={"Learn more"}
                                design={"filled"}
                                action={"internal-linking"}
                                pageLink={"/residential"}
                            />

                        </div>

                    </div>


                    <div className="max-w-[394px] mx-auto bg-card-grey h-[608px]" data-aos="fade-up" data-aos-duration="1200" data-aos-anchor-placement="top-bottom">
                        <img className="w-full" src={industry} alt="Industry" />

                        <div className='max-w-[320px] mx-auto text-center my-[40px]'>
                            <h1 className="font-noto font-bold text-[32px] leading-[40px]">Industries</h1>
                            <p className='font-alibaba text-[17px] leading-[26px] text-[#5F5D5E] mt-[20px] mb-[60px]'>Comprehensive solutions for commercial and industrial properties.</p>

                            <Button
                                name={"Learn more"}
                                design={"filled"}
                                action={"internal-linking"}
                                pageLink={"/industries"}
                            />
                        </div>
                    </div>




                    <div className="max-w-[394px] mx-auto bg-card-grey h-[608px]" data-aos="fade-up" data-aos-duration="1400" data-aos-anchor-placement="top-bottom">
                        <img className="w-full" src={liaison} alt="Liaison" />

                        <div className='max-w-[320px] mx-auto text-center my-[40px]'>
                            <h1 className="font-noto font-bold text-[32px] leading-[40px]">Liaisoning</h1>
                            <p className='font-alibaba text-[17px] leading-[26px] text-[#5F5D5E] mt-[20px] mb-[60px]'>Seamless handling of legal and regulatory requirements.</p>

                            <Button
                                name={"Learn more"}
                                design={"filled"}
                                action={"internal-linking"}
                                pageLink={"/liaison"}
                            />
                        </div>
                    </div>



                </div>
            </div>


            {/* Milestone Section */}
            <div className='bg-[#1A1A1A] text-white py-20 px-6 lg:py-32 lg:px-0' data-aos="fade-up">
                <div className='max-w-7xl mx-auto flex flex-wrap justify-between gap-y-16 text-center lg:text-left'>
                    <div className='max-w-[606px] m-auto'>
                        <h1 className='font-noto max-w-[537px] text-[35px] font-bold sm:leading-[53px] sm:text-[45px]'data-aos="fade-up">Your trusted partner in real estate</h1>
                        <p className='max-w-[510px] font-alibaba text-[20px] font-light leading-[29px] mt-[25px] mb-[60px]'data-aos="fade-up">For over 15 years, Lands and Lands has been the most comprehensive and trusted service provider across residential, commercial, industrial and liaison services for Individuals, Organizations, Government and Industry all across Tamilnadu.</p>

                        <Button
                            name={"Learn More About Us"}
                            design={"filled"}
                            action={"internal-linking"}
                            pageLink={"/about"}
                        />
                    </div>

                    <div className='max-w-[568px] mx-auto grid sm:grid-cols-2 gap-[20px]'>
                        <div className='w-[274px] h-[204px] bg-[#252525] flex flex-col justify-center items-center'data-aos="fade-up">
                            <h1 className='font-noto text-[45px] text-yellow leading-[53px]'>15+</h1>
                            <p className='font-alibaba text-[20px] leading-[28px] mt-[20px]'>Years of edge</p>
                        </div>
                        <div className='w-[274px] h-[204px] bg-[#252525] flex flex-col justify-center items-center'data-aos="fade-up">
                            <h1 className='font-noto text-[45px] text-yellow leading-[53px]'>40+</h1>
                            <p className='font-alibaba text-[20px] leading-[28px] mt-[20px]'>Services</p>
                        </div>
                        <div className='w-[274px] h-[204px] bg-[#252525] flex flex-col justify-center items-center'data-aos="fade-up">
                            <h1 className='font-noto text-[45px] text-yellow leading-[53px]'>10,000+</h1>
                            <p className='font-alibaba text-[20px] leading-[28px] mt-[20px]'>Happy Clients</p>
                        </div>
                        <div className='w-[274px] h-[204px] bg-[#252525] flex flex-col justify-center items-center'data-aos="fade-up">
                            <h1 className='font-noto text-[45px] text-yellow leading-[53px]'>5000+</h1>
                            <p className='font-alibaba text-[20px] leading-[28px] mt-[20px]'>Properties</p>
                        </div>
                    </div>
                </div>
            </div>

            <FeaturedServices />


            {/* Life at adobe */}
            <div className="mt-[141px] relative hidden sm:block" data-aos="fade-up">
                <img className="w-full object-cover md:h-[740px] hidden md:block" src={Abode_bg} alt="Abode_bg" />
                <img className="w-full object-cover h-[270px] block md:hidden" src={Abode_bg} alt="Abode_bg" />

                <div className="w-[192px] h-[218px] !opacity-95 top-8 left-12 md:w-[414px] md:h-[471px] flex flex-col items-center bg-[#111111] py-3 md:p-10 absolute md:top-40 md:left-20" data-aos="fade-up" data-aos-duration="1000" data-aos-anchor-placement="top-bottom" >

                    <img className="sm:w-[275px] sm:h-[288px] mx-auto mb-[45px]" src={Abode} alt="Abode_logo" />
                    {/* <a href={abode_pdf} target='_blank' download>
                        <button className="w-[79px] h-[23px] text-[8px] leading-3  md:w-[150px] md:h-[44px] bg-yellow text-button text-center font-alibaba md:text-[14px] font-medium md:leading-4">View Project</button>
                    </a> */}

                    <Button
                        name={"View Project"}
                        design={"filled"}
                        action={"download"}
                        sourceFile={abode_pdf}
                    />
                </div>


            </div>

            {/* Mobile Life at adobe */}
            <div className="relative sm:hidden" data-aos="fade-up">
                <img className=" w-full object-cover h-[400px]" src={Abode_bg} alt="Abode_bg" />

                <div className="w-[280px] h-[300px] flex flex-col items-center bg-[#111111] py-3 absolute inset-0 mx-auto my-auto" data-aos="fade-up" data-aos-duration="1000" data-aos-anchor-placement="top-bottom" >

                    <img className="w-[450px] h-[220px]" src={Abode} alt="Abode_logo" />

                    <Button
                        name={"View Project"}
                        design={"filled"}
                        action={"download"}
                        sourceFile={abode_pdf}
                    />

                </div>
            </div>
            
            <FormModal
                modal={modalToggle}
                active = {toggle}
            />

        </>
    );
}

export default Home;